import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import OtherTextInput from '../Components/layout/OtherTextInput';
import { POSITION_BUTTONS } from './ConstBodyPositionBtns';
import { OTHER_CKBX_VAL, isOtherChecked } from './OtherCheckboxUtils';

const POSITIONS_HELP = `
  <div>
    <p><strong>Purpose:</strong> Different physical positions may affect alternative access.    
    For example, the client may need access while using their wheelchair but also while in bed.  
    You’ll need to determine whether the basic access method will work in both positions (moving from one position to another with creative mounting), 
    or whether it would be better to have one access method in each position.  </p>
    <p>You don’t need to solve all of the issues right away, but it is good to know what issues are likely to come up in the client’s real world environment.</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  bodyPositions: PropTypes.arrayOf(PropTypes.string),
  onChangeBodyPositions: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  bodyPositions: []
};

//content sub-component with unique content for this page
class ContextsPositionsContent extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for the body positions.
  //Calls the setter that's passed in by the parent, when a checkbox is clicked.
  //That setter changes the state of the bodyPositions in the parent, 
  //which triggers a new render of the view with the new goal.

  render(){
    const firstName = this.props.firstName;
    const bodyPositions = this.props.bodyPositions ?? [];
    const onChangeBodyPositions= this.props.onChangeBodyPositions;
    const otherBodyPosition = this.props.otherBodyPosition;
    const onChangeOtherBodyPosition = this.props.onChangeOtherBodyPosition;

    let activeBtns = POSITION_BUTTONS; 
    let otherChecked = isOtherChecked(bodyPositions);

    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Check the positions where {firstName} needs access:</legend>
        {activeBtns.map((btn, index) =>
          <React.Fragment key={index}>
          <FormGroup check>
            <Input
              id={btn.value}
              value={btn.value}
              checked={bodyPositions.findIndex( (bp) => bp.startsWith(btn.value)) > -1}
              onChange={onChangeBodyPositions} 
              name="position"
              type="checkbox"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
          {/* If the btn is 'other', include a text field to specify */}
          { ((btn.value === OTHER_CKBX_VAL)) 
            ?
            <OtherTextInput
              otherChecked={otherChecked}
              otherText={otherBodyPosition}
              onChangeOtherText={onChangeOtherBodyPosition}
            />
            : null
          }
          </React.Fragment>
        )}
      </FormGroup>
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoContextsPositions(props) {
  const firstName = props.firstName;
  const bodyPositions = props.bodyPositions;
  const onChangeBodyPositions = props.onChangeBodyPositions;
  const otherBodyPosition = props.otherBodyPosition;
  const onChangeOtherBodyPosition = props.onChangeOtherBodyPosition;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoContextsPositions, body positions: " + bodyPositions);

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-users",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `What kinds of body positions is ${firstName} likely to be in?`,
    subTitle: '',
    learnMore: {linkText: "Learn More about why we ask about body positions",
                title: "Body Positions",
                content: POSITIONS_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIGPositions mounted');
    return () => {
      console.log('GIGPos unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <ContextsPositionsContent
          firstName={firstName} 
          bodyPositions={bodyPositions} 
          onChangeBodyPositions={onChangeBodyPositions}
          otherBodyPosition={otherBodyPosition}
          onChangeOtherBodyPosition={onChangeOtherBodyPosition}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoContextsPositions.propTypes = propTypes;
GatherInfoContextsPositions.defaultProps = defaultProps;

export default GatherInfoContextsPositions;